import React from "react";
import { Link } from "react-router-dom";
import "./Banner.css";

const Banner = () => {
  return (
    <section className="hero-banner-section">
      <div className="container position-relative">
        <div className="row align-items-center g-5 py-5">
          {/* Left Hero Content */}
          <div className="col-lg-7 col-md-12">
            <div className="hero-badge-pill mb-3">
              <span className="live-dot"></span>
              <span>Available for Clinical Consultations in HITEC City</span>
            </div>

            <h1 className="hero-headline">
              Restoring Active Lives with Precision
              <span className="headline-highlight"> Orthopedic Surgery</span>
            </h1>

            <p className="hero-lead-text">
              <strong>Dr. Sunil Apsingi</strong> is a distinguished Chief Arthroscopy and Joint Replacement Surgeon with over 23 years of surgical mastery. Specializing in advanced knee, shoulder, sports injury reconstruction, and robotic joint replacement.
            </p>

            <div className="hero-cta-group d-flex flex-wrap gap-3 mb-5">
              <Link to="/bookappointment" className="btn-medical-primary">
                <i className="fa-regular fa-calendar-check"></i>
                Book Consultation
              </Link>
              <Link to="/services" className="btn-medical-secondary">
                <i className="fa-solid fa-stethoscope"></i>
                Explore Surgeries
              </Link>
            </div>

            {/* Micro Trust Stats */}
            <div className="hero-stats-row">
              <div className="stat-card">
                <span className="stat-number">23+</span>
                <span className="stat-label">Years Experience</span>
              </div>
              <div className="stat-divider"></div>
              <div className="stat-card">
                <span className="stat-number">10k+</span>
                <span className="stat-label">Procedures Done</span>
              </div>
              <div className="stat-divider"></div>
              <div className="stat-card">
                <span className="stat-number">PGI</span>
                <span className="stat-label">Chandigarh Alumnus</span>
              </div>
              <div className="stat-divider"></div>
              <div className="stat-card">
                <span className="stat-number">Robotic</span>
                <span className="stat-label">Joint Surgery</span>
              </div>
            </div>
          </div>

          {/* Right Hero Image Card */}
          <div className="col-lg-5 col-md-12 text-center">
            <div className="hero-image-wrapper">
              <div className="hero-image-backdrop"></div>
              <img
                src="/images/2022-05-13.png"
                alt="Dr. Sunil Apsingi - Orthopedic Surgeon"
                className="hero-doc-photo"
              />
              <div className="floating-trust-badge">
                <div className="badge-icon">
                  <i className="fa-solid fa-award"></i>
                </div>
                <div className="text-start">
                  <strong>Senior Consultant</strong>
                  <p className="mb-0 small text-muted">Medicover Hospitals</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
